var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManagementIconAdv1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0.818115C11.215 0.818115 0 12.0331 0 25.8181C0 39.6031 11.215 50.8181 25 50.8181C38.785 50.8181 50 39.6031 50 25.8181C50 23.0031 49.51 20.3036 48.6475 17.7761L44.5996 21.824C44.8621 23.114 45 24.4506 45 25.8181C45 36.8456 36.0275 45.8181 25 45.8181C13.9725 45.8181 5 36.8456 5 25.8181C5 14.7906 13.9725 5.81812 25 5.81812C29.0825 5.81812 32.8798 7.05284 36.0498 9.16284L39.6289 5.58374C35.5089 2.59874 30.4625 0.818115 25 0.818115ZM48.2324 4.05054L22.5 29.783L14.2676 21.5505L10.7324 25.0857L22.5 36.8533L51.7676 7.58569L48.2324 4.05054Z",
    fill: "#646AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementIconAdv1);
export default __webpack_public_path__ + "static/media/management-icon-adv-1.a642b9a1f713cd97635815bb7d133e7b.svg";
export { ForwardRef as ReactComponent };